"use strict";
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateFinalNegotiationActivityDto = exports.CreateFinalNegotiationSlaDto = exports.CreateFinalNegotiationQcrVariationDto = exports.CreateFinalNegotiationSharingDetailDto = exports.CreateMeetingSummarytDto = exports.OtherCommentsFromInsurerDto = exports.CreateQuoteTaxDetailsDto = exports.netPremiumDetailsDto = exports.selectFinalisedQuoteDto = exports.PolicyDetailsDto = exports.MeetingDetailsDto = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const swagger_1 = require("@nestjs/swagger");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const create_meeting_dto_1 = require("../../meeting/dto/create-meeting.dto");
class MeetingDetailsDto {
}
exports.MeetingDetailsDto = MeetingDetailsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Final Negotiation Meeting Type ID",
        example: 343,
    }),
    (0, class_validator_1.IsInt)({ message: "Final Negotiation Meeting type must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Final Negotiation Meeting type is required." }),
    (0, class_validator_1.Min)(1, {
        message: "Final Negotiation Meeting type must be positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], MeetingDetailsDto.prototype, "isFinalNegotiationTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Selected Meeting ID",
        example: 123,
    }),
    (0, class_validator_1.IsInt)({ message: "Selected Meeting id must be a number." }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Min)(1, {
        message: "Selected Meeting id must be positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], MeetingDetailsDto.prototype, "selectMeeting", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Meeting Date",
        example: "2025-12-10",
    }),
    (0, class_validator_1.IsDate)({ message: "Meeting Date must be a valid date." }),
    (0, class_transformer_1.Type)(() => Date) // Transform string to Date
    ,
    (0, class_validator_1.IsNotEmpty)({ message: "Meeting Date is required." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Reset time to midnight
        if (value < today) {
            throw new common_1.BadRequestException("The meeting date cannot be a past date. Please provide a valid date.");
        }
        return value;
    }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], MeetingDetailsDto.prototype, "meetingDate", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Start Time (time with time zone, ISO 8601 format)",
        type: String,
        example: "10:00:00+05:30",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Start time is required." }),
    (0, class_validator_1.IsString)({
        message: "Start Time must be a string in time with time zone format (e.g., 10:00:00+05:30).",
    }),
    (0, class_transformer_1.Transform)(({ value }) => {
        // Validate ISO 8601 time with time zone (e.g., 10:00:00+05:30)
        const regex = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)([+-][0-1]\d:[0-5]\d|Z)$/;
        if (!regex.test(value)) {
            throw new common_1.BadRequestException("Start Time must be in 'HH:mm:ss±HH:mm' or 'HH:mm:ssZ' format.");
        }
        return value;
    }),
    tslib_1.__metadata("design:type", String)
], MeetingDetailsDto.prototype, "availableFrom", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "End Time (time with time zone, ISO 8601 format)",
        type: String,
        example: "11:00:00+05:30",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "End time is required." }),
    (0, class_validator_1.IsString)({
        message: "End Time must be a string in time with time zone format (e.g., 11:00:00+05:30).",
    }),
    (0, class_transformer_1.Transform)(({ value }) => {
        // Validate ISO 8601 time with time zone (e.g., 11:00:00+05:30)
        const regex = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)([+-][0-1]\d:[0-5]\d|Z)$/;
        if (!regex.test(value)) {
            throw new common_1.BadRequestException("End Time must be in 'HH:mm:ss±HH:mm' or 'HH:mm:ssZ' format.");
        }
        return value;
    }),
    tslib_1.__metadata("design:type", String)
], MeetingDetailsDto.prototype, "availableTo", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Meeting Type ID",
        example: 343,
    }),
    (0, class_validator_1.IsInt)({ message: "Meeting type must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Meeting type is required." }),
    (0, class_validator_1.Min)(1, {
        message: "Meeting type must be positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], MeetingDetailsDto.prototype, "meetingTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "KDM Meeting location",
        example: 300,
    }),
    (0, class_validator_1.IsInt)({ message: "Location type must be a number." }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Min)(1, {
        message: "Location type must be positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], MeetingDetailsDto.prototype, "locationTypeLid", void 0);
class PolicyDetailsDto {
}
exports.PolicyDetailsDto = PolicyDetailsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 310, description: "Policy placed type ID." }),
    (0, class_validator_1.IsInt)({ message: "Policy placed type ID must be an integer." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Policy placed type ID is required." }),
    (0, class_validator_1.Min)(1, {
        message: "Policy placed type ID must be a positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], PolicyDetailsDto.prototype, "policyPlacedTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 248, description: "Lead insurer ID." }),
    (0, class_validator_1.IsInt)({ message: "Lead insurer ID must be an integer." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Lead insurer ID is required." }),
    (0, class_validator_1.Min)(1, {
        message: "Lead insurer ID must be a positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], PolicyDetailsDto.prototype, "leadInsurerId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: true,
        description: "Indicates if only the lead pays commission.",
    }),
    (0, class_validator_1.IsInt)({ message: "Lead pays commission must be an integer" }),
    (0, class_validator_1.IsNotEmpty)({ message: "Lead pays commission is required." }),
    (0, class_validator_1.Min)(1, {
        message: "Lead pays commission must be a positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], PolicyDetailsDto.prototype, "isLeadInsurerPayCommissionLid", void 0);
class selectFinalisedQuoteDto {
}
exports.selectFinalisedQuoteDto = selectFinalisedQuoteDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 19, description: "Finalized version ID." }),
    (0, class_validator_1.IsInt)({ message: "Finalized version ID must be an integer." }),
    (0, class_validator_1.IsOptional)() // need to change
    ,
    (0, class_validator_1.Min)(1, {
        message: "Finalized version ID must be a positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], selectFinalisedQuoteDto.prototype, "finalizedVersionId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 19, description: "Finalized quote ID." }),
    (0, class_validator_1.IsInt)({ message: "Finalized quote ID must be an integer." }),
    (0, class_validator_1.IsOptional)() // need to change
    ,
    (0, class_validator_1.Min)(1, {
        message: "Finalized quote ID must be a positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], selectFinalisedQuoteDto.prototype, "finalizedQuoteId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: false,
        description: "Indicates if the quote is edited (optional).",
    }),
    (0, class_validator_1.IsOptional)() // need to change
    ,
    (0, class_validator_1.IsInt)({ message: "Is quote edited must be an integer." }),
    (0, class_validator_1.Min)(1, {
        message: "Is quote edited must be a positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], selectFinalisedQuoteDto.prototype, "isQuoteEdited", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 248,
        description: "Unique identifier for the insurer.",
    }),
    (0, class_validator_1.IsInt)({ message: "Insurer ID must be an integer." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Insurer ID is required." }),
    (0, class_validator_1.Min)(1, {
        message: "Insurer ID must be a positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], selectFinalisedQuoteDto.prototype, "insurerId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Quote Received Date",
        example: "2025-12-10",
    }),
    (0, class_validator_1.IsDate)({ message: "Quote Received Date must be a valid date." }),
    (0, class_transformer_1.Type)(() => Date) // Transform string to Date
    ,
    (0, class_validator_1.IsOptional)() // need to change
    ,
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], selectFinalisedQuoteDto.prototype, "quoteReceivedOn", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 10000.0,
        description: "Basic premium amount (optional).",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Basic premium must be a number." }),
    tslib_1.__metadata("design:type", Number)
], selectFinalisedQuoteDto.prototype, "basicPremium", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 500.0,
        description: "Terrorism premium amount (optional).",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Terrorism must be a number." }),
    tslib_1.__metadata("design:type", Number)
], selectFinalisedQuoteDto.prototype, "terrorism", void 0);
class netPremiumDetailsDto {
}
exports.netPremiumDetailsDto = netPremiumDetailsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 11800.0,
        description: "Net premium amount (optional).",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Net premium must be a number." }),
    tslib_1.__metadata("design:type", Number)
], netPremiumDetailsDto.prototype, "netPremium", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 10.0,
        description: "Brokerage percentage (optional).",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({}, { message: "Brokerage percentage must be a number." }),
    tslib_1.__metadata("design:type", Number)
], netPremiumDetailsDto.prototype, "brokeragePercentage", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Insurer remarks",
        description: "Remarks from the insurer (optional).",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Insurer remarks must be a string." }),
    tslib_1.__metadata("design:type", String)
], netPremiumDetailsDto.prototype, "insurerRemarks", void 0);
class CreateQuoteTaxDetailsDto {
}
exports.CreateQuoteTaxDetailsDto = CreateQuoteTaxDetailsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 18.0, description: "Tax percentage (optional)." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Tax is required" }),
    (0, class_validator_1.IsNumber)({}, { message: "Tax must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateQuoteTaxDetailsDto.prototype, "tax", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1800.0, description: "Tax value amount (optional)." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Tax value is required." }),
    (0, class_validator_1.IsNumber)({}, { message: "Tax value must be a number." }),
    tslib_1.__metadata("design:type", Number)
], CreateQuoteTaxDetailsDto.prototype, "taxValue", void 0);
class OtherCommentsFromInsurerDto {
}
exports.OtherCommentsFromInsurerDto = OtherCommentsFromInsurerDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "General remarks",
        description: "Additional remarks (optional).",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Remarks must be a string." }),
    tslib_1.__metadata("design:type", String)
], OtherCommentsFromInsurerDto.prototype, "remarks", void 0);
class CreateMeetingSummarytDto {
}
exports.CreateMeetingSummarytDto = CreateMeetingSummarytDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Summary of the meeting",
        description: "Summary of the meeting.",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Min of meeting must be a string." }),
    tslib_1.__metadata("design:type", String)
], CreateMeetingSummarytDto.prototype, "mom", void 0);
class CreateFinalNegotiationSharingDetailDto {
}
exports.CreateFinalNegotiationSharingDetailDto = CreateFinalNegotiationSharingDetailDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 248,
        description: "Unique identifier for the insurer.",
    }),
    (0, class_validator_1.IsInt)({ message: "Insurer ID must be an integer." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Insurer ID is required." }),
    (0, class_validator_1.Min)(1, {
        message: "Insurer ID must be a positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], CreateFinalNegotiationSharingDetailDto.prototype, "insurerId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 25.5,
        description: "Percentage of share allocated to the insurer.",
    }),
    (0, class_validator_1.IsNumber)({}, { message: "Share percentage must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Share percentage is required." }),
    (0, class_validator_1.Min)(0, {
        message: "Share percentage must be a non-negative number.",
    }),
    (0, class_validator_1.Max)(100, {
        message: "Share percentage must not exceed 100.",
    }),
    tslib_1.__metadata("design:type", Number)
], CreateFinalNegotiationSharingDetailDto.prototype, "sharePercentage", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 10.0,
        description: "Brokerage percentage for the insurer.",
    }),
    (0, class_validator_1.IsNumber)({}, { message: "Brokerage percentage must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Brokerage percentage is required." }),
    (0, class_validator_1.Min)(0, {
        message: "Brokerage percentage must be a non-negative number.",
    }),
    (0, class_validator_1.Max)(100, {
        message: "Brokerage percentage must not exceed 100.",
    }),
    tslib_1.__metadata("design:type", Number)
], CreateFinalNegotiationSharingDetailDto.prototype, "brokeragePercentage", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 5000.0,
        description: "Brokerage amount for the insurer.",
    }),
    (0, class_validator_1.IsNumber)({}, { message: "Brokerage amount must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Brokerage amount is required." }),
    (0, class_validator_1.Min)(0, {
        message: "Brokerage amount must be a non-negative number.",
    }),
    tslib_1.__metadata("design:type", Number)
], CreateFinalNegotiationSharingDetailDto.prototype, "brokerageAmount", void 0);
class CreateFinalNegotiationQcrVariationDto {
}
exports.CreateFinalNegotiationQcrVariationDto = CreateFinalNegotiationQcrVariationDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Variation A",
        description: "Issue of the QCR variation.",
    }),
    (0, class_validator_1.IsString)({ message: "Issue must be a string." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Issue is required." }),
    tslib_1.__metadata("design:type", String)
], CreateFinalNegotiationQcrVariationDto.prototype, "issue", void 0);
class CreateFinalNegotiationSlaDto {
}
exports.CreateFinalNegotiationSlaDto = CreateFinalNegotiationSlaDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 259, description: "Service type ID for the SLA." }),
    (0, class_validator_1.IsInt)({ message: "Service type ID must be an integer." }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Min)(1, {
        message: "Service type ID must be a positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], CreateFinalNegotiationSlaDto.prototype, "serviceTypeId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 30, description: "Number of days for the SLA." }),
    (0, class_validator_1.IsInt)({ message: "Number of days must be an integer." }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Min)(1, {
        message: "Number of days must be a positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], CreateFinalNegotiationSlaDto.prototype, "numberOfDays", void 0);
class CreateFinalNegotiationActivityDto {
}
exports.CreateFinalNegotiationActivityDto = CreateFinalNegotiationActivityDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Opportunity Activity ID",
        example: 123,
    }),
    (0, class_validator_1.IsInt)({ message: "Opportunity Activity id must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Opportunity Activity id is required." }),
    (0, class_validator_1.Min)(1, {
        message: "Opportunity Activity id must be positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], CreateFinalNegotiationActivityDto.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Final Negotiation Meeting status ID",
        example: 1,
    }),
    (0, class_validator_1.IsInt)({ message: "Status ID must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Status ID is required." }),
    (0, class_validator_1.Min)(1, {
        message: "Status ID must be positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], CreateFinalNegotiationActivityDto.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Details of the meeting.",
        type: MeetingDetailsDto,
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Meeting details are required." }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => MeetingDetailsDto),
    tslib_1.__metadata("design:type", MeetingDetailsDto)
], CreateFinalNegotiationActivityDto.prototype, "meetingDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: PolicyDetailsDto,
        description: "Policy placement details.",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Policy details are required." }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PolicyDetailsDto),
    tslib_1.__metadata("design:type", PolicyDetailsDto)
], CreateFinalNegotiationActivityDto.prototype, "policyDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: selectFinalisedQuoteDto,
        description: "Finalised quote details.",
    }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => selectFinalisedQuoteDto),
    (0, class_validator_1.IsNotEmpty)({ message: "Finalised quote details are required" }),
    tslib_1.__metadata("design:type", selectFinalisedQuoteDto)
], CreateFinalNegotiationActivityDto.prototype, "selectFinalisedQuote", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: netPremiumDetailsDto,
        description: "Finalised quote details.",
    }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => netPremiumDetailsDto),
    (0, class_validator_1.IsNotEmpty)({ message: "Finalised quote details are required" }),
    tslib_1.__metadata("design:type", netPremiumDetailsDto)
], CreateFinalNegotiationActivityDto.prototype, "netPremiumDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: [CreateQuoteTaxDetailsDto],
        description: "Finalised quote tax details.",
    }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => CreateQuoteTaxDetailsDto),
    (0, class_validator_1.IsOptional)() // need to change
    // @IsNotEmpty({ message: "Finalised quote tax details are required" })
    ,
    tslib_1.__metadata("design:type", Array)
], CreateFinalNegotiationActivityDto.prototype, "quoteTaxDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: [CreateFinalNegotiationSharingDetailDto],
        description: "Details of sharing (optional).",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)({ message: "Sharing details must be an array." }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => CreateFinalNegotiationSharingDetailDto),
    tslib_1.__metadata("design:type", Array)
], CreateFinalNegotiationActivityDto.prototype, "insurerAndBrokeragePercentage", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: [CreateFinalNegotiationQcrVariationDto],
        description: "Details of QCR variations (optional).",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)({ message: "QCR variations must be an array." }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => CreateFinalNegotiationQcrVariationDto),
    tslib_1.__metadata("design:type", Array)
], CreateFinalNegotiationActivityDto.prototype, "variationIssuesFromQCR", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: OtherCommentsFromInsurerDto,
        description: "Other comments from insurer.",
    }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => OtherCommentsFromInsurerDto),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", OtherCommentsFromInsurerDto)
], CreateFinalNegotiationActivityDto.prototype, "otherCommentsFromInsurer", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: OtherCommentsFromInsurerDto,
        description: "remarks",
    }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => OtherCommentsFromInsurerDto),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", OtherCommentsFromInsurerDto)
], CreateFinalNegotiationActivityDto.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: CreateMeetingSummarytDto,
        description: "meeting summary",
    }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => CreateMeetingSummarytDto),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", CreateMeetingSummarytDto)
], CreateFinalNegotiationActivityDto.prototype, "meetingSummary", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: [CreateFinalNegotiationSlaDto],
        description: "Details of SLA (optional).",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)({ message: "SLA details must be an array." }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => CreateFinalNegotiationSlaDto),
    tslib_1.__metadata("design:type", Array)
], CreateFinalNegotiationActivityDto.prototype, "insurerServiceLevelAgreement", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "TPA participants",
        type: create_meeting_dto_1.TpaParticipantsDto,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => create_meeting_dto_1.TpaParticipantsDto),
    tslib_1.__metadata("design:type", typeof (_c = typeof create_meeting_dto_1.TpaParticipantsDto !== "undefined" && create_meeting_dto_1.TpaParticipantsDto) === "function" ? _c : Object)
], CreateFinalNegotiationActivityDto.prototype, "tpaParticipants", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Insurer participants",
        type: create_meeting_dto_1.InsurerParticipantsDto,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => create_meeting_dto_1.InsurerParticipantsDto),
    tslib_1.__metadata("design:type", typeof (_d = typeof create_meeting_dto_1.InsurerParticipantsDto !== "undefined" && create_meeting_dto_1.InsurerParticipantsDto) === "function" ? _d : Object)
], CreateFinalNegotiationActivityDto.prototype, "insurerParticipants", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Final Negotiation meeting Participants",
        type: create_meeting_dto_1.ParticipantsDto,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => create_meeting_dto_1.ParticipantsDto),
    tslib_1.__metadata("design:type", typeof (_e = typeof create_meeting_dto_1.ParticipantsDto !== "undefined" && create_meeting_dto_1.ParticipantsDto) === "function" ? _e : Object)
], CreateFinalNegotiationActivityDto.prototype, "participants", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Covers mapping (cover ID to description).",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsObject)(),
    (0, class_transformer_1.Type)(() => Object),
    tslib_1.__metadata("design:type", typeof (_f = typeof Record !== "undefined" && Record) === "function" ? _f : Object)
], CreateFinalNegotiationActivityDto.prototype, "covers", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Finalised quote documents"
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsObject)({ message: "Finalised quote documents must be an object." }),
    (0, class_transformer_1.Type)(() => Object),
    tslib_1.__metadata("design:type", Object)
], CreateFinalNegotiationActivityDto.prototype, "quoteDocuments", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Final Negotiation Meeting documents",
        type: [create_meeting_dto_1.CreateMeetingDocumentDto],
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)({ message: "Final Negotiation Meeting documents must be an array." }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => create_meeting_dto_1.CreateMeetingDocumentDto),
    tslib_1.__metadata("design:type", Array)
], CreateFinalNegotiationActivityDto.prototype, "documents", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], CreateFinalNegotiationActivityDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], CreateFinalNegotiationActivityDto.prototype, "updatedBy", void 0);
